// ProtectedRoute.js
import React from "react";
import { Navigate } from "react-router-dom";
import { isAuthenticated, isAdmin } from "../services/auth";

function ProtectedRoute({ children, role }) {
  // Check if the user is authenticated
  if (!isAuthenticated()) {
    return <Navigate to="/login" />;
  }

  // Check if the user has the required role (if a role is passed in)
  if (role === "admin" && !isAdmin()) {
    return <Navigate to="/" />; // Redirect non-admin users to the home page
  }

  return children;
}

export default ProtectedRoute;
